import styled from 'styled-components'
import { Button } from 'antd'

export const SidebarBtn = styled(Button)`
  color: #000c17;
  text-align: left;
  width: 100%;
  border: none;
  padding: .5rem;

  :hover {
    color: #000c17;
  }

  svg {
    color: #000c17;
  }
`